import { Injectable } from '@angular/core';
import { SidenavItem } from './sidenav-item/sidenav-item.interface';

import { defaultTypes } from 'src/environments/configs';
import { ReportListComponent } from 'src/app/modules/reports/report-list/report-list.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class SidenavNavigationData {
  constructor(private dialog: MatDialog) {}

  openQuickPanel(): void {
    return;
  }

  openImportMenu(): void {
    this.dialog.open(ReportListComponent);
  }

  navigationAppItems: SidenavItem[] = [
    {
      name: 'Applications',
      position: 1,
      type: 'subheading',
      customClass: 'first-subheading'
    },
    {
      routeOrFunction: (): void => {
        this.openQuickPanel();
      },
      name: 'Messagerie',
      icon: 'mail',
      position: 2,
      pathMatchExact: true,
      badgeId: 'chat',
      badgeColor: '#ff0000'
    }
  ];

  actPosition = 5;

  navigationItems: SidenavItem[] = [
    {
      name: 'Acts',
      position: this.actPosition,
      type: 'subheading',
      customClass: 'first-subheading'
    },

    {
      routeOrFunction: '/data/NaturalPerson/list/',
      name: defaultTypes.physicalPerson.title,
      icon: defaultTypes.physicalPerson.icon,
      position: defaultTypes.physicalPerson.order + this.actPosition,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/data/MoralPerson/list/',
      name: defaultTypes.moralPerson.title,
      icon: defaultTypes.moralPerson.icon,
      position: defaultTypes.moralPerson.order + this.actPosition,
      pathMatchExact: true
    },

    {
      routeOrFunction: '/data/PhysicalEntity/list/',
      name: defaultTypes.physicalEntity.title,
      icon: defaultTypes.physicalEntity.icon,
      position: defaultTypes.physicalEntity.order + this.actPosition,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/data/Act/list/',
      name: defaultTypes.folder.title,
      icon: defaultTypes.folder.icon,
      position: defaultTypes.folder.order + this.actPosition,
      pathMatchExact: true
    },

    {
      name: 'Gestion',
      position: 26,
      type: 'subheading',
      customClass: 'first-subheading'
    },
    {
      routeOrFunction: '/data/Report/list/',
      name: defaultTypes.report.title,
      icon: defaultTypes.report.icon,
      position: 27,
      pathMatchExact: true
    },

    {
      routeOrFunction: '/data/Gallery/list/',
      name: defaultTypes.gallery.title,
      icon: defaultTypes.gallery.icon,
      position: 28,
      pathMatchExact: true
    }
  ];

  navigationImportItem: SidenavItem[] = [
    {
      routeOrFunction: (): void => {
        this.openImportMenu();
      },
      name: 'Import',
      icon: 'download',
      position: 29,
      pathMatchExact: true,
      badgeId: 'download',
      badgeColor: '#ff0000'
    }
  ];

  navigationAdminItems: SidenavItem[] = [
    {
      name: 'Admin Actions',
      position: 30,
      type: 'subheading',
      customClass: 'first-subheading'
    },

    {
      routeOrFunction: '/data/UserClient/list/',
      name: 'Clients app mobile',
      icon: 'people_outline',
      position: 35,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/data/DcbmService/list/',
      name: 'Services',
      icon: 'ballot',
      position: 40,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/data/UserAdmin/list/',
      name: 'Collaborateurs',
      icon: 'contacts',
      position: 45,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/data/TemplateAct/list/',
      name: 'Modèles de dossier',
      icon: 'extension',
      position: 50,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/data/TemplateComponent/list/',
      name: 'Composants des modéles',
      icon: 'widgets',
      position: 51,
      pathMatchExact: true
    },
    // eslint-disable-next-line @typescript-eslint/quotes
    /* {
      routeOrFunction: '/data/ActType/list/',
      name: 'Types de dossiers',
      icon: 'description',
      position: 55,
      pathMatchExact: true
    }, */
    {
      routeOrFunction: '/data/DocumentType/list/',
      name: 'Types de Document',
      icon: 'collections',
      position: 60,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/data/DcbmFormList/list/',
      name: 'Listes pour les formulaire',
      icon: 'list',
      position: 65,
      pathMatchExact: true
    },
    /*  {
      routeOrFunction: '/data/Document/list/',
      name: 'Documents',
      icon: 'picture_as_pdf',
      position: 70,
      pathMatchExact: true
    }, */
    // {
    //   routeOrFunction: '/data/Message/list/',
    //   name: 'Messages',
    //   icon: 'forum',
    //   position: 75,
    //   pathMatchExact: true
    // },
    {
      routeOrFunction: '/data/RentReportMonthly/list/',
      name: 'Rapports Mensuels',
      icon: 'assessment',
      position: 80,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/data/RentReportYearly/list/',
      name: 'Rapports annuels',
      icon: 'book',
      position: 85,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/data/MobileAppCategory/list/',
      name: 'Catégorie App Mobile',
      icon: 'phone',
      position: 90,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/data/UserDevices/list/',
      name: 'Devices Autorisées',
      icon: 'contact_phone',
      position: 90,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/storage',
      name: 'Stockage',
      icon: 'storage',

      position: 100,
      pathMatchExact: true
    },
    {
      name: 'Log',
      position: 105,
      type: 'subheading',
      customClass: 'first-subheading'
    },
    /* {
      routeOrFunction: '/data/Log/list',
      name: 'Log',
      icon: 'list',

      position: 110,
      pathMatchExact: true
    }, */
    {
      routeOrFunction: '/data/AuthClientLog/list',
      name: 'Client Connection',
      icon: 'list',

      position: 110,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/data/AuthAdminLog/list',
      name: 'Admin Connection',
      icon: 'list',

      position: 120,
      pathMatchExact: true
    },
    {
      routeOrFunction: '/data/ImportLog/list',
      name: 'Import',
      icon: 'list',

      position: 130,
      pathMatchExact: true
    }
  ];
}
